import BackIcon from '@mui/icons-material/ArrowBack';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { FormattedMessage, useIntl } from 'react-intl';

import { getRouteApi, useNavigate } from '@tanstack/react-router';
import Spacings from '~/modules/ui-kit/spacings';

import ContentView from '~/components/ContentView';
import NewsEntryForm from '~/containers/NewsEntryForm';
import { useCreateNewsEntry } from '~/hooks/api/useCreateNewsEntry';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import messages from './messages';

const route = getRouteApi('/news-entries/create');

export const NewsEntryCreate = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const search = route.useSearch();
  const handleBackButton = () => {
    navigate({ to: search.from || '/news-entries' });
  };
  const createNewsEntryMutation = useCreateNewsEntry({
    onSuccess: () => {
      showSnackbar({
        message: intl.formatMessage(messages.saveSuccess),
      });
      handleBackButton();
    },
    onError: () => {
      showSnackbar({
        message: intl.formatMessage(messages.saveFailure),
      });
    },
  });
  return (
    <ContentView
      header={
        <AppBar position="static">
          <Toolbar>
            <Spacings.Inline alignItems="center">
              <IconButton
                color="inherit"
                onClick={handleBackButton}
                size="large"
              >
                <BackIcon data-testid="back" />
              </IconButton>
              <div>
                <Typography
                  variant="h6"
                  sx={{
                    color: 'inherit',
                  }}
                >
                  <FormattedMessage {...messages.title} />
                </Typography>
              </div>
            </Spacings.Inline>
          </Toolbar>
        </AppBar>
      }
      isLoading={createNewsEntryMutation.isPending}
    >
      <NewsEntryForm
        onSubmit={(values) => {
          createNewsEntryMutation.mutate({
            ...values,
            visibility: Object.keys(values.visibility).filter(
              (key) => values.visibility[key as keyof typeof values.visibility]
            ),
          });
        }}
      />
    </ContentView>
  );
};

export default NewsEntryCreate;
